import { AgmCoreModule } from "@agm/core";
import { ErrorHandler, NgModule } from "@angular/core";
import { Component } from "@angular/core";
import { Platform } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { App, NavController, NavParams } from "ionic-angular";
import { ConfigService } from '../../providers/dbservice/configservice';
import { Member } from "../../models/interfaces/member.model";
import { Document } from "../../models/interfaces/document.model";
import { ExpensesPage } from "../../pages/expenses/expenses";
import { HarelinePage } from "../../pages/hareline/hareline";
import { HarelineUpdatePage } from "../../pages/hareline/hareline_update";
import { PledgeAddPage } from "../../pages/pledge/pledge_add";
import { RatingPage } from "../../pages/rating/rating";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

export interface Rrating {
  rt_name: string;
  rt_ratings: [{ mb_hashname: string, rt_value: number }];
}

@NgModule({
  imports: [
    AgmCoreModule
  ]
})

@Component({
  selector: "page-hareline_view",
  templateUrl: "hareline_view.html",
})

export class HarelineViewPage {
  private chapter: string;


  addItem(newItem: string) {
    newItem.split(":", 2);
    if (newItem.split(":", 2)[0] === "LOAcnt") {
      this.LOAcntAttended = Number(newItem.split(":", 2)[1]);
    }
    if (newItem.split(":", 2)[0] === "mbrcnt") {
      this.membercntAttended = Number(newItem.split(":", 2)[1]);
    }
    if (newItem.split(":", 2)[0] === "guestcnt") {
      this.guestcnt = Number(newItem.split(":", 2)[1]);
    }
    if (newItem.split(":", 2)[0] === "guestttl") {
      this.sguestttl = Number(newItem.split(":", 2)[1]).toFixed(2);
    }
    this.updateFin();
  }
  public static readonly NEWSLETTER_ADD_ACCESS = "addNewsletter";
  public static readonly HARELINE_UPD_ACCESS = "updateHareline";
  public static readonly HARELINE_DEL_ACCESS = "deleteHareline";
  public static readonly RATING_UPD_ACCESS = "updateRating";
  public static readonly EXPENSES_VIEW_ACCESS = "viewExpenses";
  public static readonly EXPENSES_ADD_ACCESS = "addExpenses";
  public static readonly PLEDGE_ADD_ACCESS = "addPledge";
  public static readonly FINANCE_VIEW_ACCESS = "viewFinance";
  private exportFileName = "HarelineView";
  private exportViewName = "vw_export_hareline";
  private hasAddNewsletterAccess: boolean = false;
  private LOAcnt: number = 0;
  private LOAcntAll: number = 0;

  private LOAcntAttended: number = 0;
  private LOAttl: string;
  private LOAfee: number = 0;
  private membercntAll: number = 0;
  private membercntAttended: number = 0;
  private memberttl: string;
  private memberfee: number = 0;
  private guestcnt: number = 0;
  private pledgettl: string;
  private guestttl: number = 0;
  private sguestttl: string;
  private sincttl: string;
  private incttl: number = 0;
  private expttl: string;
  private finttl: string;


  public catRating: number = 0;
  public avgCatRating: number = 0;
  public totRating: number = 0;
  public avgRating: number = 0;
  private currentUser: Member;
  private displayPic: boolean = false; // Suppress photos for components
  private page: string = "pledge";
  private hasUpdHarelineAccess: boolean = false;
  private hasDelHarelineAccess: boolean = false;
  private hasUpdRatingAccess: boolean = false;
  private hasViewExpensesAccess: boolean = false;
  private hasAddExpensesAccess: boolean = false;
  private hasAddPledgeAccess: boolean = false;
  private hasAddAttendanceAccess: boolean = false;
  private hasViewFinanceAccess: boolean = false;
  private objectKeys = Object.keys;
  private hl_datetime: string;
  private hl_publish: boolean;
  private hl_hare: string;
  private hl_runno: string;
  private hl_runsite: string;
  private hl_gps: string;
  private hl_id: number;
  private hl_gps_lat: number;
  private hl_gps_lng: number;
  private hl_runtype: string;
  private hl_runfee: string;
  private hl_guestfee: string;
  private hl_comment: string;
  private member: Member;
  private userRating$: any;
  private pledge$: any;
  private pledge: any;
  private attendance$: any;
  private attendance_confirmed$: any;
  private attendanceTTL$: number;
  private distinct_status = [];
  private enabledistinct_status: boolean = false;
  private StatuscntAll = [];
  private mbrFee = [];
  private status_all = [];
  private hl_scribe$: any;
  private scribe = "";
  private comments = [];
  private hl_hare$: any;
  private document$: any;
  private expenses$: any;
  private guest_fee$: any;
  private guest_feeAll$: any;
  private isFirstLoad: Boolean = true;
  private isPutin: Boolean = false;
  private hare = "";
  private hareline: any;
  private mRating = {} as Rrating;
  private rating;
  private rating_item;
  private exAmountTTL: number;
  private showAttendance: boolean = true;
  private showPledge: boolean = true;
  private showFinance: boolean = true;
  private showRating: boolean = true;
  private enableRating: boolean = false;
  private enablePledge: boolean = false;
  private enablePledgeBtn: boolean = false;
  private enablePullCardBtn: boolean = false;
  private showRun: boolean = true;
  private mRatings = [];
  private mRatingsCnt = [];
  private mRatingsAvgCnt = [];
  private presentDay: Date;
  private styleName: string ="";
  private isCommentsVisible: boolean = false;
  public href: string = "";
  controllerDocURI;

  constructor(private configService: ConfigService, public app: App, public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController, private db: DbserviceProvider, public platform: Platform,
  ) {
    console.log("HarelineViewPage constructor");
    this.controllerDocURI = configService.getConfig('DOC_URL');
    this.hasAddNewsletterAccess = this.db.hasAccess(HarelineViewPage.NEWSLETTER_ADD_ACCESS);

    this.styleName=this.configService.getConfig("STYLENAME");
    
    if (this.navParams.get("hareline") === undefined) {
      this.hl_id = 0;
    }
    else {
      this.hareline = this.navParams.get("hareline")[0];
      if (this.hareline.cp_name !== "Dog Hash") {
        this.enablePledgeBtn = true;
        this.enablePullCardBtn = true;
        this.enabledistinct_status = true;
      }
      this.chapter = this.hareline.cp_name;
      this.hl_gps = this.hareline.hl_gps;
      this.hl_runno = this.hareline.hl_runno;
      this.hl_id = this.hareline.hl_id;
      this.hl_datetime = this.hareline.hl_datetime;
      this.exAmountTTL = this.hareline.ex_amount_ttl;
      if (this.authService.currentUser) {
        this.updateFin();
      }
    }

    if (this.authService.currentUser) {
      this.hasUpdHarelineAccess = this.db.hasAccess(HarelineViewPage.HARELINE_UPD_ACCESS);
      this.hasDelHarelineAccess = this.db.hasAccess(HarelineViewPage.HARELINE_DEL_ACCESS);
      this.hasAddPledgeAccess = this.db.hasAccess(HarelineViewPage.PLEDGE_ADD_ACCESS);
      this.hasViewExpensesAccess = this.db.hasAccess(HarelineViewPage.EXPENSES_VIEW_ACCESS);
      this.hasAddExpensesAccess = this.db.hasAccess(HarelineViewPage.EXPENSES_ADD_ACCESS);
      this.hasViewFinanceAccess = this.db.hasAccess(HarelineViewPage.FINANCE_VIEW_ACCESS);
    }

  }

  private updateFin() {
    console.log("HarelineViewPage updateFin");

    if (this.sguestttl === undefined) {
      this.sguestttl = String(0);

    }
    if (this.enabledistinct_status) {
      this.sincttl = String(Number(this.incttl) + Number(this.sguestttl));
      this.expttl = Number(this.exAmountTTL).toFixed(2);
      this.finttl = Number(Number(this.sincttl) - Number(this.expttl)).toFixed(2);


    }
    else {
      this.sincttl = String(Number(this.sguestttl));
      this.expttl = Number(this.exAmountTTL).toFixed(2);
      this.finttl = Number(Number(this.sincttl) - Number(this.expttl)).toFixed(2);
    }
    console.log("HarelineViewPage updateFin end");
  }

  private ionViewWillEnter() {
    console.log("HarelineViewPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("HarelineViewPage onInitPage");

    this.mRatings = [];
    this.mRatingsCnt = [];
    this.mRatingsAvgCnt = [];

    // Just in case no hareline is defined all fields will show blank
    if (this.navParams.get("hareline") === undefined) {
      this.hl_id = 0;
    }
    else {
      if (this.authService.currentUser) {

        this.db.dbCol({
          "action": "select", "mapObject": "vw_hareline_comments",
          "sqlExtended": " where hl_id = " + this.hl_id,
        }).subscribe((x) => {
          if (x.length !== 0) {
            this.isCommentsVisible = true;
          }
          this.comments = x;
        });

        // Number of LOA's and Regular members for Cost Overview
        this.db.dbCol({
          "action": "select", "mapObject": "member",
          "sqlExtended": " where st_byfee_flg=1 ",
        }).subscribe((mbr) => {
          this.distinct_status = mbr.reduce((prev, { st_id, st_name }) =>
            prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name }], [])
          this.distinct_status.push()

          this.distinct_status.forEach((element, index, array) => {
            this.StatuscntAll[element.st_id] = Number(mbr.filter(data => data.st_name == element.st_name).length);
          });

          this.db.dbCol({
            "action": "select", "mapObject": "settings",
            "sqlExtended": " where st_byfee_flg=1 and se_class='Payment' ",
          }).subscribe((mbr) => {
            this.distinct_status = mbr.reduce((prev, { st_id, st_name, se_attribute2, se_key_value }) =>
              prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name, se_attribute2, se_key_value }], [])
            this.distinct_status.push();

            this.distinct_status.forEach((element, index, array) => {
              this.mbrFee[element.st_id] = element;
              this.incttl = this.incttl + Number(this.StatuscntAll[element.st_id] * this.mbrFee[element.st_id].se_key_value / this.mbrFee[element.st_id].se_attribute2)
            })
            this.updateFin();
          });
        });

        // Ratings Section
        this.db.dbCol({
          "action": "select", "mapObject": "rating",
          "sqlExtended": "  order by rt_order",
        }).subscribe((rt) => {
          this.rating = rt;

          if (this.rating.length > 0) {

            this.enableRating = true;
          }
        });

        this.db.dbCol({
          "action": "select", "mapObject": "hareline_rating_item",
          "sqlExtended": "  where hl_id = " + this.hl_id,
        }).subscribe((hrt) => {
          this.rating_item = hrt;
          let nObjects = 0;
          this.totRating = 0;
          this.rating_item.map((ri) => {
            this.totRating = this.totRating + parseFloat(ri.hi_value);
            nObjects++;
            if (this.mRatings[ri.rt_id] !== undefined) {
              this.mRatings[ri.rt_id] = this.mRatings[ri.rt_id] + parseFloat(ri.hi_value);
              this.mRatingsCnt[ri.rt_id] = this.mRatingsCnt[ri.rt_id] + 1;
              this.mRatingsAvgCnt[ri.rt_id] = (this.mRatings[ri.rt_id] / this.mRatingsCnt[ri.rt_id]).toFixed(1);
            }
            else {
              this.mRatings[ri.rt_id] = parseFloat(ri.hi_value);
              this.mRatingsCnt[ri.rt_id] = 1;
            }
          },
          );
          this.avgRating = parseFloat((this.totRating / nObjects).toFixed(1));
        }); // End Rating

        // Pledges Section
        this.db.dbCol({
          "action": "select", "mapObject": "pledge", "sqlExtended": " where pledge.hl_id = '" +
            this.hl_id + "'",
        }).subscribe((pl) => {
          this.pledge = pl;
          if (pl.length !== 0) {
            this.enablePledge = true;
          }

          this.pledgettl = Number(0).toFixed(2);
          pl.forEach((p) => {
            this.pledgettl = Number(Number(this.pledgettl) + Number(p.pl_amount)).toFixed(2);
          });
          this.updateFin();
        })
        // this.document$ = this.db.dbCol({ "action": "select", "mapObject": "document", "sqlExtended": " where hl_id='" + this.hl_runno + "'" });

        this.db.dbCol({
          "action": "select", "mapObject": "vw_expenses",
          "sqlExtended": " where se_class='Expenses' and hl_id = " + this.hl_id + " order by ex_amount desc",
        }).subscribe((x) => {
          this.expenses$ = x;
        });


      } // Logged in

      this.db.dbCol({
        "action": "select", "mapObject": "vw_expenses",
        "sqlExtended": " where se_class='Expenses' and hl_id = " + this.hl_id + " order by ex_amount desc",
      }).subscribe((x) => {
        this.expenses$ = x;
      });

      let rundate = this.hl_datetime;
      var followingDay = new Date(new Date(this.hl_datetime).getFullYear(), new Date(this.hl_datetime).getMonth() , new Date(this.hl_datetime).getDate() + 4).toISOString().slice(0, 10); // + 1 day in ms
      var newDate = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate(), new Date().getHours() + 8).toISOString().slice(0, 10);



      if (newDate >= rundate && newDate <= followingDay) {
        this.hasAddAttendanceAccess = true;
        this.hasUpdRatingAccess = true;
      }


      // GPS Coordinates
      if (this.hareline.hl_gps != null) {
        this.hl_gps_lat = parseFloat(this.hareline.hl_gps.split(",")[0]);
        this.hl_gps_lng = parseFloat(this.hareline.hl_gps.split(",")[1]);
      }


      this.scribe = "";
      this.hare = "";
      this.exAmountTTL = this.navParams.get("hareline")[0].ex_amount_ttl;
      this.updateFin();

      // Get Hares and Scribe
      this.navParams.get("hareline").forEach((assistant) => {
        if (assistant.mb_id == 1) {
          this.isPutin = true;
        }
        if (assistant.hs_type === "H") {
          this.hare = this.hare + assistant.mb_hashname + ",";
        }
        else if (assistant.hs_type === "S") {
          this.scribe = this.scribe + assistant.mb_hashname + ",";
        }

      });
      //Trim last comma
      this.scribe = this.scribe.slice(0, -1);
      this.hare = this.hare.slice(0, -1);
      this.db.dbCol({
        "action": "select", "mapObject": "guest_fee",
        "sqlExtended": " where  hl_id = " + this.hl_id + " order by gf_name",
      }).subscribe((x) => {
        this.guest_feeAll$ = this.guest_fee$ = x;
      });
    }

  }

  private launchNativeMap(latlong: string) {
    let label = encodeURI("RunSite");

    if (this.platform.is("ios")) {
      window.open("maps://?q=" + latlong, "_system");
    }
    else if (this.platform.is("android")) {
      window.open("geo:0,0?q=" + latlong + "(" + label + ")", "_system");
    }
    else {
      window.open("https://www.google.com/maps/search/?api=1&query=" + latlong, "_system");
    }
  }

  private ngOnDestroy() {
    console.log("HarelineViewPage ngOnDestroy");
  }
  /*
    private viewDocument(document: Document) {
      console.log("HarelineViewPage viewDocument");
      window.open(encodeURI(this.controllerDocURI + "/" + document.do_filename), "_system", "location=no");
    }*/

  private deleteHareline(id: any) {
    console.log("HarelineViewPage deleteHareline");
    this.showConfirm("Hareline", "Do you want to delete the Hareline?", id);
  }

  private showConfirm(title: string, message: string, id: string) {
    console.log("HarelinePage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "DELETE FROM hareline WHERE hareline.hl_id=" + this.hl_id,
            })
              .subscribe((ret) => {
                this.navCtrl.pop();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {
          },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }

  private updateHareline() {
    console.log("HarelineViewPage updateHareline");
    this.navCtrl.push(HarelineUpdatePage, {
      "hareline": this.hareline,
      "guestfee": this.guest_feeAll$,
    });
  }

  private rateHareline(id: string) {
    console.log("HarelineViewPage rateHareline");
    this.navCtrl.push(RatingPage, {
      "hareline": this.hareline,
      "isPutin": this.isPutin,
    });
  }

  private addExpenses(id: string) {
    console.log("HarelineViewPage addExpenses");
    this.navCtrl.push(ExpensesPage, {
      "hareline": this.navParams.get("hareline"),
    });
  }

  private addPledge(id: string) {
    console.log("HarelineViewPage addPledge");
    this.navCtrl.push(PledgeAddPage, {
      "hareline": this.navParams.get("hareline")
    });
    // Pledges Section
    this.db.dbCol({
      "action": "select", "mapObject": "pledge", "sqlExtended": " where pledge.hl_id = '" +
        this.hl_id + "'",
    }).subscribe((pl) => {
      this.pledge = pl;
    });
  }


  private addAttendance(id: string) {
    console.log("HarelineViewPage addAttendance");
    let lmb_id;

    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        (user) => {
          lmb_id = user.mb_id;
        },
      );
    }

    const attendanceValues: any = {
      "at_confirmed_flg": 0,
      "hl_id": this.hl_id,
      "mb_id": lmb_id,
    };

    this.attendance$ = this.db.dbCol({
      "action": "select", "mapObject": "attendance", "sqlExtended": " where attendance.hl_id = '" +
        this.hl_id + "' and attendance.mb_id = '" + lmb_id + "'",
    });

    this.attendance$.subscribe((atd) => {
      if (atd.length === 0) {
        this.showAddAttendance("Attendance", "Do you want to register your attendance?", null, attendanceValues, false);
      }
      else {
        this.showAddAttendance("Attendance", "Do you want to register your attendance?", atd[0].hl_id, attendanceValues, true);
      }
    });
  }

  private toggleRun() {
    console.log("HarelineViewPage toggleRun");
    this.showRun = !this.showRun;
  }

  private toggleRating() {
    console.log("HarelineViewPage toggleRun");
    this.showRating = !this.showRating;
  }

  private togglePledge() {
    console.log("HarelineViewPage toggleRun");
    this.showPledge = !this.showPledge;
  }
  private toggleFinance() {
    console.log("HarelineViewPage toggleRun");
    this.showFinance = !this.showFinance;
  }

  private showAddAttendance(title: string, message: string, id: string, attendanceValues: {}, exists: boolean) {
    console.log("HarelineViewPage showAddAttendance");
    let confirm = this.alertCtrl.create({
      "title": title,
      "message": message,
      "buttons": [
        {
          "text": "Yes",
          "handler": () => {
            if (exists) {
              this.db.dbCol({ "action": "update", "mapObject": "attendance", "at_id": id, ...attendanceValues })
                .subscribe((ret) => {
                  this.attendance$ = this.db.dbCol({
                    "action": "select", "mapObject": "attendance", "sqlExtended": " where attendance.hl_id = '" +
                      this.hl_id + "' order by at_confirmed_flg"
                  }).subscribe((ln) => {
                  });
                }
                );
            }
            else {
              this.db.dbCol({ "action": "insert", "mapObject": "attendance", ...attendanceValues })
                .subscribe((ret) => {
                }
                );
            }
          },
        },
        {
          "handler": () => {

          },
          "text": "No",
        },
      ],
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/hareline/hareline_view.ts